import { Schedule } from "./Schedule";

export const SchedulePage = () => {
  return <Schedule />;
};
